<template>
  <div class="px-3">
    <h1 class="primary--text">
      Notification Settings
    </h1>
    <v-simple-table style="width: 100%;">
      <thead>
        <tr>
          <td style="width: 70%">
            Notification
          </td>
          <td
            style="width: 15%"
            align="center"
          >
            Email
          </td>
          <td
            style="width: 15%"
            align="center"
          >
            App Notification
          </td>
        </tr>
      </thead>
      <tbody>
        <template v-for="(item, index) in notifications">
          <NotificationSettingItem
            :key="index"
            :item="item"
            @update:item="updateSettings(index, $event)"
          />
        </template>
      </tbody>
    </v-simple-table>
  </div>
</template>
<script>
import NotificationSettingItem from './NotificationSettingItem.vue'
import NotificationSettingsSerializer from './NotificationSettingsSerializer'
export default {
  components: { NotificationSettingItem },
  props: {
    settings: { type: Object, required: true }
  },
  data() {
    return {
      notifications: NotificationSettingsSerializer.toList(this.settings)
    }
  },
  methods: {
    updateSettings(index, value) {
      this.notifications[index] = value
      this.$emit('update:settings', this.notifications)
    }
  }
}
</script>
